/** Perfis de sistema aplicados no cadastro de usuário, sem clamp pelo criador. */

export const SYSTEM_DEFAULT_PROFILE = {
  TRANSPORTADORA: "Transportadora (padrão)",
  EMBARCADOR: "Embarcador (padrão)",
};

export const SYSTEM_DEFAULT_PROFILE_OPTIONS = [
  {
    value: SYSTEM_DEFAULT_PROFILE.TRANSPORTADORA,
    label: SYSTEM_DEFAULT_PROFILE.TRANSPORTADORA,
  },
  {
    value: SYSTEM_DEFAULT_PROFILE.EMBARCADOR,
    label: SYSTEM_DEFAULT_PROFILE.EMBARCADOR,
  },
];

const off = () => ({
  selecionarTodos: false,
  isView: false,
  isCreate: false,
  isEdit: false,
  isDelete: false,
});

const crud = () => ({
  selecionarTodos: true,
  isView: true,
  isCreate: true,
  isEdit: true,
  isDelete: true,
});

const viewOnly = () => ({
  selecionarTodos: false,
  isView: true,
  isCreate: false,
  isEdit: false,
  isDelete: false,
});

const viewEdit = () => ({
  selecionarTodos: false,
  isView: true,
  isCreate: false,
  isEdit: true,
  isDelete: false,
});

const EMPTY_PERMISSOES = {
  salesDashboard: off(),
  freight: off(),
  freightPricing: off(),
  freightDriver: off(),
  freightFreight: off(),
  freightViewEditDriver: off(),
  freightCannotRelease: off(),
  freightStoppingPointLatLong: off(),
  client: off(),
  driver: off(),
  shipper: off(),
  vehicle: off(),
  user: off(),
  product: off(),
  simulatorFreight: off(),
  lances: off(),
  filasTransportadoras: off(),
  budget: off(),
  mdfe: off(),
  revenue: off(),
  import: off(),
  payment: off(),
  freightControl: off(),
  freightControlDocuments: off(),
  freightControlBoleto: off(),
  tableIcms: off(),
  ocurrence: off(),
  tablePrice: off(),
  accompaniment: off(),
  perfil: off(),
  generalReport: off(),
  paymentCondition: off(),
};

function buildPermissoes(overrides = {}) {
  return {
    ...EMPTY_PERMISSOES,
    ...overrides,
  };
}

const TRANSPORTADORA_PERMISSOES = buildPermissoes({
  client: crud(),
  user: crud(),
  driver: crud(),
  shipper: viewOnly(),
  vehicle: crud(),
  freight: viewEdit(),
  lances: viewOnly(),
  accompaniment: viewOnly(),
  freightPricing: viewOnly(),
  freightDriver: viewEdit(),
  freightFreight: viewOnly(),
  freightCannotRelease: viewOnly(),
});

const EMBARCADOR_PERMISSOES = buildPermissoes({
  client: crud(),
  user: crud(),
  driver: crud(),
  shipper: crud(),
  vehicle: crud(),
  freight: crud(),
  simulatorFreight: viewOnly(),
  filasTransportadoras: viewOnly(),
  accompaniment: viewOnly(),
  freightPricing: viewEdit(),
  freightFreight: viewEdit(),
});

const PROFILE_PERMISSOES_MAP = {
  [SYSTEM_DEFAULT_PROFILE.TRANSPORTADORA]: TRANSPORTADORA_PERMISSOES,
  [SYSTEM_DEFAULT_PROFILE.EMBARCADOR]: EMBARCADOR_PERMISSOES,
};

export function isSystemDefaultProfile(perfilName) {
  return Boolean(PROFILE_PERMISSOES_MAP[perfilName]);
}

export function getSystemDefaultPermissoes(perfilName) {
  const source = PROFILE_PERMISSOES_MAP[perfilName];
  if (!source) return null;

  return Object.keys(EMPTY_PERMISSOES).reduce((acc, key) => {
    const group = source[key] || off();
    acc[key] = { ...group };
    return acc;
  }, {});
}

function normalizePerfilLabel(perfilName) {
  return String(perfilName || "")
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .toLowerCase()
    .trim();
}

function shipperIsTransport(shipper) {
  if (!shipper || typeof shipper !== "object") return false;
  const value = shipper.isTransport;
  return (
    value === true ||
    value === 1 ||
    String(value).toLowerCase() === "true"
  );
}

function isTransportadoraActor(user, shipper) {
  const perfil = normalizePerfilLabel(user?.perfil);
  if (perfil.includes("transportadora")) return true;
  if (user?.Transportadora === true || user?.transportadora === true) return true;
  return shipperIsTransport(shipper);
}

function isEmbarcadorActor(user) {
  const perfil = normalizePerfilLabel(user?.perfil);
  return perfil.includes("embarcador");
}

/**
 * Transportadora: só "Transportadora (padrão)".
 * Embarcador ou viewALL: todos os perfis padrão.
 */
export function getVisibleSystemDefaultProfileOptions(user, shipper = null) {
  if (user?.viewALL === true || isEmbarcadorActor(user)) {
    return SYSTEM_DEFAULT_PROFILE_OPTIONS;
  }

  if (isTransportadoraActor(user, shipper)) {
    return SYSTEM_DEFAULT_PROFILE_OPTIONS.filter(
      (option) => option.value === SYSTEM_DEFAULT_PROFILE.TRANSPORTADORA,
    );
  }

  return SYSTEM_DEFAULT_PROFILE_OPTIONS;
}

/** Pode criar perfil customizado apenas com permissão do menu Perfil (`perfil.isView`). */
export function canCreateCustomPerfil(user) {
  if (user?.viewALL === true) return true;
  return Boolean(user?.permissoes?.perfil?.isView);
}
